import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PermissionGuard2 from '../../Layout/PermissionGuard2';

import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Lazy load components for better performance
const BankList = lazy(() => import('../BankDetailsTab/BankDetails'));

/**
 * Store module routes
 * @param {Object} props - Component props
 * @returns {JSX.Element} - Store routes
 */
const SettingsRoute = (props) => {
    const { history } = props;
    return (
        <>
            <Route
                exact
                path="/:lng/settings/bank_details"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <BankList history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
        </>
    );
};
function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
export default SettingsRoute;
